var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.ValidationProvider, {
    staticClass: "component-container",
    attrs: { rules: _setup.props.validationRules },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ errors }) {
          return [
            _c("div", { staticClass: "input-container" }, [
              _c("label", { attrs: { for: _setup.props.id } }, [
                _vm._v(_vm._s(_setup.props.placeholder)),
              ]),
              _c(
                "div",
                {
                  staticClass: "input-field",
                  class: { "error-style": errors[0] },
                },
                [
                  _c("div", { staticClass: "prepend-icon" }, [
                    _c("span", { class: _setup.props.prependIcon }),
                  ]),
                  _c("input", {
                    attrs: {
                      type: _setup.inputType,
                      placeholder: _setup.props.placeholder,
                      id: _setup.props.id,
                      name: _setup.props.id,
                      autocomplete: _setup.props.autocompleteType,
                    },
                    domProps: { value: _setup.props.value },
                    on: { input: _setup.emitValue },
                  }),
                  _c("div", { staticClass: "append-icon" }, [
                    _c("span", {
                      class: _setup.props.appendIcon,
                      on: { click: _setup.toggleVisible },
                    }),
                  ]),
                ]
              ),
            ]),
            errors
              ? _c("div", { staticClass: "alert-container" }, [
                  _c("span", { staticClass: "alert-text" }),
                  _vm._v(" " + _vm._s(errors[0])),
                ])
              : _vm._e(),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }